/**
 * @generated SignedSource<<b3b359a0272774ffdc16db7a217b2668>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_transaction$data = {
  readonly isGiftEligible: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_transaction" | "CheckoutGifting_transaction" | "CheckoutMobileSummaryNewPane_transaction" | "CheckoutRestrictionAcknowledgement_transaction" | "CheckoutReviewStepChargesDisclaimer_transaction" | "CheckoutReviewStepDeliveryView_transaction" | "CheckoutSubmitButton_transaction" | "CheckoutTaxExemptionCheckbox_transaction" | "CheckoutVatReverseChargeCheckbox_transaction" | "useUpdateShipmentQuote_transaction">;
  readonly " $fragmentType": "CheckoutReviewStep_transaction";
};
export type CheckoutReviewStep_transaction$key = {
  readonly " $data"?: CheckoutReviewStep_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepChargesDisclaimer_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRestrictionAcknowledgement_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepDeliveryView_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPane_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutGifting_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutVatReverseChargeCheckbox_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUpdateShipmentQuote_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGiftEligible",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "94b83bad8e6150c2eba2fb32012980c3";

export default node;
